import { PageHero } from "@/components/site/PageParts";
import { Reveal } from "@/lib/motion";

const IMG = "https://images.unsplash.com/photo-1542460533-50ac46fb13d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxzaWxob3VldHRlJTIwY291cGxlJTIwc2hhZG93fGVufDB8fHx8MTc4NTk0NTgwMXww&ixlib=rb-4.1.0&q=85";

const VALUES = [
  { n: "01", t: "Privacy is a right", d: "Not a feature you unlock. We minimise data collection and never sell your information." },
  { n: "02", t: "Consent is the baseline", d: "Every interaction on Doublelist begins and continues with mutual, informed agreement." },
  { n: "03", t: "Adults, always", d: "We are strictly 18+ and work continuously to keep minors and bad actors off the platform." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero
        index="A/"
        overline="About Us"
        titleLines={["A discreet home", <>for <span className="italic text-oxblood">adult</span> connection</>]}
        intro="Interlaced Social LLC builds calm, private spaces for adults to connect on their own terms."
      />

      <section className="mx-auto max-w-[1400px] px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-oxblood mb-6">Who we are</p>
            <p className="font-serif text-3xl sm:text-4xl leading-[1.15] tracking-tight mb-8">
              Doublelist is operated by <span className="italic">Interlaced Social LLC</span>, a company devoted to safe, consensual, adults-only connection.
            </p>
            <div className="space-y-5 text-ink-soft leading-relaxed text-lg">
              <p>
                We started with a simple belief: adults deserve a personal
                classifieds and social space that respects them. That means
                discretion by default, clear community standards, and a hard line
                against anything illegal or exploitative.
              </p>
              <p>
                We are not a marketplace for services and we never will be.
                Doublelist is a community of consenting adults — nothing more,
                nothing less.
              </p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-6">
          <div className="relative overflow-hidden border border-line aspect-[4/5]">
            <img src={IMG} alt="Adult connection" className="clip-frame w-full h-full object-cover" />
          </div>
        </Reveal>
      </section>

      <section className="border-t border-line">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-20 md:py-28">
          <Reveal>
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight mb-16">
              What we <span className="italic text-oxblood">stand for</span>
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-12">
            {VALUES.map((v, i) => (
              <Reveal key={v.n} delay={i * 0.08}>
                <div className="border-t border-ink pt-6">
                  <span className="font-serif text-5xl text-oxblood">{v.n}</span>
                  <h3 className="font-serif text-2xl mt-3 mb-3">{v.t}</h3>
                  <p className="text-ink-soft leading-relaxed">{v.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
